import { createFileRoute } from '@tanstack/react-router';
import { BenefitCatalogEditPage } from './BenefitCatalogEditPage';

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/benefit-catalog/$entryId/edit/',
)({
  component: BenefitCatalogEditPage,
});
